import { FormGroup, IFormGroupProps, ISliderProps, Slider } from '@blueprintjs/core'
import React, { SFC } from 'react'

import { FieldAdapterProps } from './types'

export type Props = FieldAdapterProps<ISliderProps & IFormGroupProps>

const SliderAdapter: SFC<Props> = ({ input, meta, label, helperText, disabled, min, max }) => {
  const { name: id } = input

  return (
    <FormGroup label={label} labelFor={id} disabled={disabled} helperText={helperText}>
      <Slider min={min} max={max} onChange={input.onChange} />
    </FormGroup>
  )
}

export { SliderAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/slider-adapter.tsx